export default {
      id: "icon-phone-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-phone",
      toString: function () {
        return this.url;
      }
    }